import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ArrowBackIcon = createIcon(
  'ArrowBack',
  <path
    id="a"
    d="M14.91,6.71 C14.52,6.32 13.89,6.32 13.5,6.71 L8.91,11.3 C8.52,11.69 8.52,12.32 8.91,12.71 L13.5,17.3 C13.89,17.69 14.52,17.69 14.91,17.3 C15.3,16.91 15.3,16.28 14.91,15.89 L11.03,12 L14.91,8.12 C15.29,7.73 15.29,7.09 14.91,6.71 Z"
  />
);

export default ArrowBackIcon;
